// Central logo asset mapping. Drop a file into public/logos/ and point
// the brand's entry at its path — the interface needs no other changes.
// null = clean typographic wordmark fallback.
export const LOGOS = {
  hilton: '/logos/hilton.svg',
  vivo: '/logos/vivo.svg',
  bosch: '/logos/bosch.svg',
  shell: '/logos/shell.svg',
  adidas: '/logos/adidas.svg',
  cocacola: '/logos/cocacola.svg',
  citroen: '/logos/citroen.svg',
  pantone: null,
  tdbank: null,
  canadagoose: null,
  valuevillage: null,
  haagendazs: null,
  careem: null,
  comfort: null,
  surfexcel: null,
  subway: null,
  bajajfinserv: null,
  parle: null,
  gillette: null,
  vicks: null,
  dabur: null,
  lionsgateplay: null,
  epified: null,
  beingindian: null,
  dronestark: null,
  mimamsa: null,
  porsche: null,
  govdco: null,
  della: null,
};
